import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-industries-container',
  imports: [CommonModule,RouterModule],
  standalone: true,
  templateUrl: './industries-container.component.html',
  styleUrl: './industries-container.component.scss'
})
export class IndustriesContainerComponent {

}
